
import LinkIcon from '@material-design-icons/svg/filled/link.svg?component'
import React from 'react'
import { connect } from 'react-redux'

import { ability } from '../../ability'
import { Action, Permission } from '../../ability/types'
import { withLegacyRouter } from '../../decorators'
import { DefaultClaimsTable } from '../claim-history/default-table'
import { DiagnosesClaimsTable } from '../claim-history/diagnoses-table'
import { MedicationsClaimsTable } from '../claim-history/medications-table'
import { ProvidersClaimsTable } from '../claim-history/providers-table'
import { Card, Button } from '../shared/NarusMaterial'

import { patientFolderClose } from './Assessment/actions'
import CaseManagement from './CaseManagement'
import ClinicalImpressions from './ClinicalImpressions'
import Documents from './Documents'
import EncounterHistoryModal from './EncounterHistoryModal'
import IGAO from './IGAO'
import { Medications } from './Standard/Medications/medications'
import { TimelineV2 } from './Timeline/timelineV2'

class PatientFolder extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      openEncounterHistoryModal: false
    }
    this.closeEncounterHistory = this.closeEncounterHistory.bind(this)
    this.openEncounterHistory = this.openEncounterHistory.bind(this)
  }

  componentDidMount () {
    localStorage.removeItem('asUserId') // Added to clear assuming the role of user outside an Encounter
    const { dispatch } = this.props
    dispatch(patientFolderClose())
  }

  closeEncounterHistory () {
    this.setState({
      openEncounterHistoryModal: false
    })
  }

  openEncounterHistory () {
    this.setState({
      openEncounterHistoryModal: true
    })
  }

  renderEncounterHistoryModal () {
    const { params } = this.props
    const { openEncounterHistoryModal } = this.state
    if (!openEncounterHistoryModal) {
      return null
    }
    const actions = [
      <Button
        key={1}
        onClick={this.closeEncounterHistory}
        label='Close'
      />
    ]

    return (
      <EncounterHistoryModal
        params={params}
        actions={actions}
        onClose={this.closeEncounterHistory}
      />
    )
  }

  render () {
    const { caseClosure, params, userEmail } = this.props
    const activityTitle = (
      <button
        className='card-title link-title'
        onClick={this.openEncounterHistory}
      >
        {' '}
        Activity
        <LinkIcon fill='#222' />
      </button>
    )

    return (
      <div className='patient-folder'>
        <CaseManagement caseClosureProps={caseClosure} />

        <div className='row'>
          <div className='col-xs-12 col-sm-8'>
            <div className='row'>
              <div className='col-xs-12'>
                <Card>
                  <IGAO
                    params={params}
                    patientFolder
                  />
                </Card>
              </div>
            </div>
            <div className='row'>
              <div className={`col-xs-12 col-sm-${ability.can(Action.ALL, Permission.ACTIVE_MEDICATIONS) ? 6 : 12}`}>
                <Card title='Documents'>
                  <Documents
                    patientId={params.id}
                    clientName={params.clientName}
                  />
                </Card>
              </div>
              {ability.can(Action.ALL, Permission.ACTIVE_MEDICATIONS) && (
                <div className='col-xs-12 col-sm-6'>
                  <Card title='Active Medications'>
                    <Medications
                      isPatientBanner
                      patientId={params.id}
                    />
                  </Card>
                </div>
              )}
            </div>
          </div>
          <div className='col-xs-12 col-sm-4'>
            <Card
              title={activityTitle}
              height={474}
            >
              <TimelineV2 />
            </Card>
          </div>
        </div>
        <div className='row'>
          <div className='col-xs-12 col-sm-12'>
            <Card height={300}>
              <ClinicalImpressions params={params} />
            </Card>
          </div>
        </div>

        {(userEmail === 'pavlyshina@health-samurai.io') && (
          <>
            <DefaultClaimsTable />
            <DiagnosesClaimsTable />
            <MedicationsClaimsTable />
            <ProvidersClaimsTable />
          </>
        )}

        {this.renderEncounterHistoryModal()}
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  userEmail: redux?.auth?.profile?.email ?? null,
  caseClosure: redux.caseClosure
})

export default connect(mapStateToProps)(withLegacyRouter(PatientFolder))
